import { render, staticRenderFns } from "./CardArticle.vue?vue&type=template&id=2aafb2de&"
import script from "./CardArticle.vue?vue&type=script&lang=js&"
export * from "./CardArticle.vue?vue&type=script&lang=js&"
import style0 from "./CardArticle.vue?vue&type=style&index=0&id=2aafb2de&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports